import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=a875d186&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a875d186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a875d186')) {
      api.createRecord('a875d186', component.options)
    } else {
      api.reload('a875d186', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=a875d186&scoped=true&", function () {
      api.rerender('a875d186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ss7mg8owysBL/JS/comp/Voucher-Unit.vue"
export default component.exports